import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 880px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th120>分類名稱</Th120>
        <Th120>會計科目 (專案)</Th120>
        <Th120>會計科目</Th120>
        <Th160>備註</Th160>
        <Th120>狀態</Th120>
        <Th120>刪除</Th120>
        <Th120>明細</Th120>
      </TableRow>
    </THead>
  );
};

export default Header;
